export enum OnboardingWizardActions {
  // FIRST PAGE - COMPANY IDENTIFICATION
  ON_FIRST_PAGE_NEXT_CLICK_SUCCESS = 'primeira_tela_sucesso',
  ON_FIRST_PAGE_NEXT_CLICK_UNSUCCESS = 'primeira_tela_insucesso',
  ACCEPT_TERMS = 'aceite_termos',

  // SECOND PAGE - COMPANY INFO
  IS_NEW_CNPJ = 'cnpj_novo',
  VALID_CNPJ = 'cnpj_valido',
  INVALID_CNPJ = 'cnpj_invalido',
  INACTIVE_CNPJ = 'cnpj_inativo',
  IS_SMALL_BUSINESS = 'cnpj_MEI',
  ON_SEARCH_CNPJ_CLICK = 'buscar_cnpj',
  ON_COMPANY_DATA_NEXT_CLICK = 'tela_cnpj_proximo',

  // THIRD PAGE - LOAN DATA
  NUMBER_OF_INSTALLMENTS_12 = 'parcela_12',
  NUMBER_OF_INSTALLMENTS_15 = 'parcela_15',
  NUMBER_OF_INSTALLMENTS_18 = 'parcela_18',
  NUMBER_OF_INSTALLMENTS_21 = 'parcela_21',
  NUMBER_OF_INSTALLMENTS_24 = 'parcela_24',
  ON_LOAN_DATA_NEXT_CLICK = 'tela_solicitacao_proximo',

  // FORTH PAGE - ADDRESS
  ON_ZIPCODE_SEARCH_CLICK = 'buscar_CEP',
  ON_ADDRESS_NEXT_CLICK = 'tela_endereco_proximo',

  // FIFTH PAGE - SOCIAL MEDIA
  ON_SOCIAL_MEDIA_NEXT_CLICK = 'tela_redes_sociais_proximo',

  // SIXTH PAGE - CREATE ACCOUNT
  CREATED_ACCOUNT = 'Criacao_conta_pj',
  SEND_SOLICITATION = 'enviar_solicitacao',
  SEND_SOLICITATION_ERROR = 'enviar_solicitacao_insucesso',

  // SEVENTH PAGE - PHONE VALIDATION
  VALIDATED_PHONE_CODE = 'codigo_SMS',
  RESENT_PHONE_CODE_VALIDATION = 'reenviar_SMS',

  // EIGHTTH PAGE - EMAIL VALIDATION
  VALIDATED_EMAIL_CODE = 'codigo_email',
  RESENT_EMAIL_CODE_VALIDATION = 'reenviar_SMS',

  // FEEDBACK PAGES
  INITIAL_ANALYSIS = 'funil_onboarding',
  SOLICITATION_SUCCESS = 'tela_solicitacao_enviada',
  DENIED_MEI = 'tela_negado_MEI',
  DENIED_OTHERS = 'tela_negado_outros',

  // INNER LOGIN PAGE
  ON_INNER_LOGIN_NEXT_CLICK = 'fluxo_quebrado_próximo'
}
